import { PipeResponse } from 'src/types/pipes.types';
import { routeMessage } from '../network/messageRouter';

import {
  webSocketDatasetsEventMessages,
  webSocketPipesEventMessages,
  webSocketSystemsEventMessages,
} from '../types/network.types';

import type { SocketIOInstance, WebSocketEventMessages } from '../types/network.types';
import type { System } from '../types/system.types';
import type { Dataset } from '../types/dataset.types';

const messageHandler = (
  type: WebSocketEventMessages['type'],
  entities: Record<string, PipeResponse> | Record<string, System> | Record<string, Dataset>
) => {
  const incomingEntities = Object.values(entities);

  if (incomingEntities) {
    routeMessage({ type, data: incomingEntities } as WebSocketEventMessages);
  }
};

export const usePipesLiveUpdates = (socket: SocketIOInstance | null) => {
  webSocketPipesEventMessages.forEach((messageType) => {
    socket?.on(messageType, (data) => {
      messageHandler(messageType, data.data ?? {});
    });
  });
};

export const useSystemsLiveUpdates = (socket: SocketIOInstance | null) => {
  webSocketSystemsEventMessages.forEach((messageType) => {
    socket?.on(messageType, (data) => {
      messageHandler(messageType, data.data ?? {});
    });
  });
};

export const useDatasetsLiveUpdates = (socket: SocketIOInstance | null) => {
  webSocketDatasetsEventMessages.forEach((messageType) => {
    socket?.on(messageType, (data) => {
      messageHandler(messageType, data.data ?? {});
    });
  });
};
